document.querySelector(".hamburger").addEventListener("click", function () {
	this.classList.toggle("active");

	const mobileMenu = document.querySelector(".mobile-menu");
	const body = document.body;

	if (this.classList.contains("active")) {
		mobileMenu.classList.add("active");
		body.classList.add("no-scroll");
	} else {
		mobileMenu.classList.remove("active");
		body.classList.remove("no-scroll");
	}
});

// Select all toggle buttons
const toggleButtons = document.querySelectorAll(".js-toggle-child");

// Add click event listener to each button
toggleButtons.forEach((button) => {
	button.addEventListener("click", function (e) {
		e.preventDefault();

		// Find the parent li element (2 levels up: div -> div -> li)
		const parentLi = this.closest("li");

		// Toggle the 'active' class
		if (parentLi) {
			parentLi.classList.toggle("active");
		}
	});
});

// Video Text video play/pause
(function () {
	function updateIcons(btn, isPlaying) {
		var pauseIcon = btn.querySelector(".icon-pause");
		var playIcon = btn.querySelector(".icon-play");

		if (pauseIcon) pauseIcon.style.display = isPlaying ? "" : "none";
		if (playIcon) playIcon.style.display = !isPlaying ? "" : "none";
	}

	document.addEventListener("click", function (e) {
		var btn = e.target.closest(".block-media-text .play-pause");
		if (!btn) return;

		var block = btn.closest(".block-media-text");
		if (!block) return;

		var iframeVideo = block.querySelector("iframe[data-provider]");
		var mp4Video = block.querySelector('video[data-provider="mp4"]');

		var isPlaying = btn.classList.contains("is-playing");

		// MP4 video
		if (mp4Video) {
			if (isPlaying) mp4Video.pause();
			else mp4Video.play();

			btn.classList.toggle("is-playing");
			updateIcons(btn, !isPlaying);
			return;
		}

		// Iframe video (YouTube / Vimeo / Wistia)
		if (!iframeVideo || !iframeVideo.contentWindow) return;

		var provider = iframeVideo.getAttribute("data-provider");
		if (!provider) return;

		if (provider === "youtube") {
			iframeVideo.contentWindow.postMessage(
				JSON.stringify({
					event: "command",
					func: (isPlaying ? "pause" : "play") + "Video",
					args: [],
				}),
				"*",
			);
		} else if (provider === "wistia") {
			var src = iframeVideo.getAttribute("src") || "";
			var match = src.match(/embed\/iframe\/([a-z0-9]+)/);
			if (!match) return;

			var videoId = match[1];
			window._wq = window._wq || [];

			window._wq.push({
				id: videoId,
				onReady: function(video) {
					isPlaying ? video.pause() : video.play();
				}
			});
		} else {
			// Vimeo only
			iframeVideo.contentWindow.postMessage(
				{ method: isPlaying ? "pause" : "play" },
				"*"
			);
		}

		btn.classList.toggle("is-playing");
		updateIcons(btn, !isPlaying);
	});
})();

// Accordion Toggle
(function () {
	document.addEventListener("click", function (e) {
		var trigger = e.target.closest(".block-accordion .heading-row");
		if (!trigger) return;

		var item = trigger.closest(".accordion-item");
		if (!item) return;

		item.classList.toggle("is-open");
	});
})();

// Slider blocks slick init
jQuery(function ($) {
	$(".block-image-slider, .block-review-slider").each(function () {
		const $block = $(this);
		const $slider = $block.find(".slider");

		if (!$slider.length) return;

		const slidesToShow = $block.hasClass("stacked-slide") ? 2 : 1;

		$slider.slick({
			slidesToShow: slidesToShow,
			slidesToScroll: 1,
			arrows: true,
			dots: false,
			adaptiveHeight: false,

			responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
					},
				},
			],

			prevArrow: `
        <span class="slick-prev">
          <svg width="14" height="21" viewBox="0 0 14 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="2.81229" height="14.0614" transform="matrix(0.737154 -0.675725 0.737154 0.675725 0.628906 10.0347)" />
            <rect width="2.81229" height="14.0614" transform="matrix(-0.737154 -0.675725 0.737154 -0.675725 2.70166 11.9346)" />
          </svg>
        </span>
      `,
			nextArrow: `
        <span class="slick-next">
          <svg width="14" height="21" viewBox="0 0 14 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="2.81229" height="14.0614" transform="matrix(-0.737154 0.675725 -0.737154 -0.675725 12.8086 10.1216)" />
            <rect width="2.81229" height="14.0614" transform="matrix(0.737154 0.675725 -0.737154 0.675725 10.7358 8.22168)" />
          </svg>
        </span>
      `,
		});
	});
});

// Location Card - Map
(function () {
    function initLocationMaps() {
        document.querySelectorAll(".location-map").forEach(function (el) {
            const zoom    = parseInt(el.dataset.zoom || "15", 10);
            const pinUrl  = el.dataset.pin;
            const locations = JSON.parse(el.dataset.locations || "[]");

            if (!locations.length) return;

            const map = new google.maps.Map(el, {
                zoom: zoom,
                center: { lat: locations[0].lat, lng: locations[0].lng },
                mapTypeControl: false,
                streetViewControl: false,
                fullscreenControl: false,
                clickableIcons: false,
                disableDefaultUI: true,
            });

            const bounds = new google.maps.LatLngBounds();

            locations.forEach(function (loc) {
                if (Number.isNaN(loc.lat) || Number.isNaN(loc.lng)) return;

                const markerOpts = {
                    position: { lat: loc.lat, lng: loc.lng },
                    map: map
                };

                if (pinUrl) {
                    markerOpts.icon = {
                        url: pinUrl,
                        scaledSize: new google.maps.Size(40, 56),
                    };
                }

                new google.maps.Marker(markerOpts);
                bounds.extend(markerOpts.position);
            });

            if (locations.length > 1) {
                map.fitBounds(bounds);
            }
        });
    }

    window.initLocationMaps = initLocationMaps;
})();


// Stat Card - Count Up Animation
(() => {
  const nums = document.querySelectorAll('.block-stat-card .stat-number[data-target]');
  if (!nums.length) return;

  const duration = 1400;

  const animate = (el) => {
    if (el.dataset.animated) return;

    const raw = (el.dataset.target || '').trim();
    const match = raw.match(/^([^0-9\-+]*)([-+]?\d[\d,]*\.?\d*)(.*)$/);
    if (!match) return;

    el.dataset.animated = '1';

    const prefix = match[1];
    const numStr = match[2];
    const suffix = match[3];

    const value = parseFloat(numStr.replace(/,/g, ''));
    const decimals = (numStr.split('.')[1] || '').length;

    const start = performance.now();

    const tick = (now) => {
      const t = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - t, 3);
      const current = value * eased;

      el.textContent = `${prefix}${current.toFixed(decimals)}${suffix}`;

      if (t < 1) requestAnimationFrame(tick);
      else el.textContent = `${prefix}${value.toFixed(decimals)}${suffix}`;
    };

    requestAnimationFrame(tick);
  };

  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      animate(entry.target);
      io.unobserve(entry.target);
    });
  }, { threshold: 0.25 });

  nums.forEach((el) => io.observe(el));
})();